<div class="loader-wrapper" [class.hide-loader]="!show">
    <img class="img-fluid" src="assets/images/logo/logo-TotalEnergies.svg" alt="Logo TotalEnegies" />
</div>
